import React, { useState } from "react";
import api from "../services/api.js";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FaEdit } from "react-icons/fa";

import { IoMdClose } from "react-icons/io";
import DeleteButton from "./DeleteButton.jsx";

const AddContainers = ({
  containers,
  addContainer,
  removeContainer,
  updateContainer,
}) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [editingContainerId, setIsEditingContainerId] = useState(null);
  const [editedContainer, setEditedContainer] = useState({});
  const [editErrorMessage, setEditErrorMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const containerSchema = z.object({
    type_container: z.string().min(1, "O nome é obrigatório"),
    sizeInCm: z.string().regex(/^\d{1,4}x\d{1,4}x\d{1,4}$/, {
      message: "Formato de tamanho invalido",
    }),
  });

  console.log(containers);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: zodResolver(containerSchema) });

  const onFormSubmit = async (values) => {
    try {
      console.log("values: ", values);
      const response = await api.post(`/containers/create-container`, values);
      addContainer(response.data);
      reset();
    } catch (error) {
      console.error("Erro ao criar container: ", error);
    }
  };

  const handleEditClick = (container) => {
    setIsEditingContainerId(container.id);
    setEditedContainer(container);
    setEditErrorMessage("");
  };

  const handleSaveClick = async (id) => {
    try {
      const { createdAt, updatedAt, ...containerData } = editedContainer;

      const validation = containerSchema.safeParse(containerData);

      if (!validation.success) {
        setEditErrorMessage(
          `Por favor, revise o tipo do Container e tente novamente`
        );
        return;
      }

      await api.put(`/containers/${id}`, containerData);

      updateContainer(id, containerData);
      setEditErrorMessage("");
      setIsEditingContainerId(null);
    } catch (error) {
      console.error("Erro inesperado:", error);
      setEditErrorMessage("Ocorreu um erro ao salvar. Tente novamente.");
    }
  };

  const handleDeleteContainer = async (id) => {
    try {
      await api.delete(`/containers/${id}`);
      removeContainer(id);
    } catch (error) {
      console.error("erro ao excluir Contêiner: ", error);

      setErrorMessage(
        "Erro ao excluir Contêiner. Verifique se algum pedido utiliza esse contêiner"
      );
      return "Erro ao excluir Contêiner. Verifique se algum pedido utiliza esse contêiner";
    }
  };

  const handleInputChange = (e, field) => {
    setEditedContainer({ ...editedContainer, [field]: e.target.value });
  };

  return (
    <div className="bg-[#F2F2F2] rounded-md px-2 pb-4 pt-8 mt-4 ml-2 h-90  text-boldGray opacity-90">
      <table className="w-full border-gray-300">
        <thead>
          <tr className="h-16 flex">
            <th className="flex-1 text-center">CONTÊINERES</th>
          </tr>
        </thead>
        <tbody>
          <div className="overflow-y-auto custom-scrollbar h-[200px]">
            <div className="mr-4">
              {containers.map((container) => {
                return (
                  <tr
                    className="h-20  flex  rounded-md bg-gray-200 mt-4 relative items-center justify-center"
                    key={container.id}
                  >
                    {editingContainerId === container.id ? (
                      <>
                        {editErrorMessage && (
                          <div className="absolute -top-4">
                            <p className="text-red-500  text-sm">
                              {editErrorMessage}
                            </p>
                          </div>
                        )}
                        <td className="flex-1 text-center">
                          <input
                            value={editedContainer.type_container || ""}
                            onChange={(e) =>
                              handleInputChange(e, "type_container")
                            }
                            className="w-full h-full text-center border border-gray-300 rounded p-2 box-border"
                          />
                        </td>
                        <div className="ml-2 flex gap-x-2">
                          <button
                            onClick={() => handleSaveClick(container.id)}
                            className="bg-green-500 text-white px-2 py-1 rounded"
                          >
                            Salvar
                          </button>
                          <button
                            className="text-2xl"
                            onClick={() => setIsEditingContainerId(null)}
                          >
                            <IoMdClose />
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="flex">
                          <td className="flex items-center w-[10rem]">
                            <div
                              className="flex-grow text-center"
                              style={{ width: "40%" }}
                            >
                              {container.type_container.toUpperCase()}
                            </div>
                          </td>
                          <td className="flex items-center w-[10rem]">
                            <div
                              className="flex-grow text-center"
                              style={{ width: "40%" }}
                            >
                              {/* //TODO: Se for mesmo dessa forma. ver se há necessidade de fazer um edit para o tamanho do container */}
                              {(container.sizeInCm / 1000000).toFixed(3)} m³
                            </div>
                          </td>
                          <div
                            className="flex flex-col gap-y-4 items-end "
                            style={{ width: "20%" }}
                          >
                            <button onClick={() => handleEditClick(container)}>
                              <FaEdit />
                            </button>
                            <DeleteButton
                              onConfirm={() =>
                                handleDeleteContainer(container.id)
                              }
                              errorMessage={errorMessage}
                              setErrorMessage={setErrorMessage}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </tr>
                );
              })}
            </div>
          </div>
        </tbody>
      </table>

      <form onSubmit={handleSubmit(onFormSubmit)} className="w-full flex mt-4">
        <input
          placeholder="Tipo de Contêiner"
          className="w-full py-2 px-4 text-center border-r"
          {...register("type_container")}
        />
        <input
          placeholder="Tamanho cm x cm x cm"
          className="w-full py-2 px-4 text-center"
          {...register("sizeInCm")}
        />

        <button
          className="w-1/4 py-2 px-4 bg-orange-500 text-white hover:bg-orange-600"
          type="submit"
        >
          +
        </button>
      </form>

      {Object.keys(errors).length > 0 && (
        <p className="text-red-500 mt-4">
          Por favor, verifique os dados e tente novamente.
        </p>
      )}

      {/* {sucessMessage && <p className="mt-2">{sucessMessage}</p>} */}
    </div>
  );
};

export default AddContainers;
